export default function HomePage() {
  return (
    <div className="space-y-2">
      <h1 className="text-3xl font-semibold tracking-tight">Home</h1>
      <p className="text-muted-foreground">
        Resumen del estado del marketplace.
      </p>
    </div>
  );
}
